/* eslint-disable @next/next/no-img-element */
import React, {useMemo} from 'react';

import {App, Orientation} from '@web-catalog/types';

import styles from './PreviewScreens.module.scss';

type Props = {
  screens: App['fileUrls'];
  orientation: Orientation;
};

export const PreviewScreens: React.FC<Props> = ({orientation, screens}) => {
  const screensForView = useMemo(() => {
    if (orientation === Orientation.PORTRAIT) {
      return screens
        .filter((screen) => screen.orientation === Orientation.PORTRAIT)
        .slice(0, 3);
    }

    if (orientation === Orientation.LANDSCAPE) {
      return screens
        .filter((screen) => screen.orientation === Orientation.LANDSCAPE)
        .slice(0, 1);
    }

    return [];
  }, [orientation, screens]);

  return (
    <div className={styles.wrapper}>
      {screensForView.map((screen, index) => (
        <img
          key={screen.fileUrl}
          src={screen.fileUrl}
          alt={`Скриншот ${index + 1}`}
          className={styles[orientation]}
          style={
            screensForView.length !== 3 ? {justifyContent: 'space-around'} : {}
          }
        ></img>
      ))}
    </div>
  );
};
